import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';

type RequestPasswordResetRequest = {
  email: string;
};

type RequestPasswordResetResponse = {
  success: boolean;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: RequestPasswordResetRequest }
): Promise<RequestPasswordResetResponse> =>
  await denApi.post<RequestPasswordResetResponse, RequestPasswordResetRequest>(
    'password-reset/request',
    arg
  );

/**
 * Hook to request a password reset email.
 * Always returns success to avoid leaking whether the email exists.
 */
export function useRequestPasswordReset(
  swrOptions?: SWRMutationConfiguration<
    RequestPasswordResetResponse,
    Error,
    string,
    RequestPasswordResetRequest
  >
) {
  const { trigger, isMutating, error, reset } = useSWRMutation<
    RequestPasswordResetResponse,
    Error,
    string,
    RequestPasswordResetRequest
  >('password-reset/request', fetcher, swrOptions);

  return {
    requestReset: trigger,
    isLoading: isMutating,
    error,
    clearError: reset,
  };
}
